import { CONFIG } from '../helper/config';
import { getRequestOptions, handleResponse,handleError } from './service-utilities';

/**
 * Service for handling error logging through the error boundary API.
 *
 * Provides methods to record and send error information to the backend
 * for monitoring and troubleshooting.
 */
export const errorBoundaryService = {
    /** Logs a new error to the backend error boundary API. */
    logNewError,
};

/*
request error boundary api to log new error
*/
function logNewError( auth_token:string,error_info) {
    let url = CONFIG.API.BASEURL + CONFIG.API.BACKEND  +CONFIG.API.REQUESTURL.LOGERROR    
    let request_options : any = getRequestOptions(CONFIG.API.REQUESTMETHOD.POST,auth_token ,JSON.stringify(error_info))
    return fetch(url, request_options).then(handleResponse).catch(handleError);
}